import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props } from './componentEl-fcbc301e.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { a as addSpacingClasses, m as marginPropTypes, p as paddingPropTypes } from './spacing-0f39ba4a.js';
import { g as getZIndex, z as zIndexProps } from './zIndex-60238fbe.js';

/**
 * Generates a wrapper that makes elements stick to the top, bottom, left, or right of page
 * via position: sticky, fixed, or absolute
 */
const Sticky = /*#__PURE__*/React.forwardRef(({
  componentEl: Component,
  children,
  className,
  margin,
  padding,
  type,
  position,
  zIndex,
  fullWidth,
  fullHeight,
  placeholder,
  disabled,
  // eslint-disable-next-line react/prop-types
  style,
  ...otherProps
}, ref) => {
  let cssClasses = ['st_sticky'];
  if (!disabled) {
    cssClasses.push(`st_position--${type}`);
  } else {
    cssClasses.push('st_position--rel');
  }
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    padding,
    margin,
    cssClasses
  });
  cssClasses = addClassNames(getZIndex(zIndex), cssClasses);
  if (fullWidth) cssClasses.push('st_width--full');
  if (type === 'fixed' && fullHeight) cssClasses.push('st_pageheight--full');
  if (type !== 'fixed' && fullHeight) cssClasses.push('st_height--full');
  const styles = style || {};
  if (position) styles[position] = '0';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
    className: cssClasses.join(' '),
    style: styles,
    ref: ref
  }), children), placeholder && !disabled && /*#__PURE__*/React.createElement("div", {
    className: "st_sticky__ph"
  }, placeholder));
});
Sticky.displayName = 'Sticky';
Sticky.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for element, if any */
  margin: marginPropTypes,
  /** padding for element, if any */
  padding: paddingPropTypes,
  /** which method to use for element to be sticky. */
  type: PropTypes.oneOf(['fixed', 'sticky']),
  /** whether to set height to 100% */
  fullWidth: PropTypes.bool,
  /** whether to set height to 100% */
  fullHeight: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'right', 'left', 'bottom']),
  /**
   * z-index for sticky header container.
   * Ignored for static header. One of `minor`, `mid`, `mad`, `major`, `top` */
  zIndex: zIndexProps,
  /** placeholder element to take up space, if needed */
  placeholder: PropTypes.any,
  /** disable sticky behavior */
  disabled: PropTypes.bool
};
Sticky.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  padding: null,
  type: 'sticky',
  zIndex: 'major',
  fullWidth: false,
  fullHeight: false,
  position: 'top',
  placeholder: null,
  disabled: false
};
var Sticky$1 = Sticky;

export { Sticky$1 as S };
